import {call, put,takeLatest} from 'redux-saga/effects';
import * as cartService from "../../../services/cartService"
import {
    INCREASE_CART_COUNT,
    INCREASE_CART_COUNT_SUCCESS,
    INCREASE_CART_COUNT_ERROR
}
    from "../../actions/cart";

function* increaseCartCountSaga(action) {
    try {
        const data=yield call(cartService.IncreaseCartCount,action.payload)
        yield put({
            type: INCREASE_CART_COUNT_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: INCREASE_CART_COUNT_ERROR,error: error.data
        });
    }
}


export function* increaseCartCountSagaWatcher() {
    yield takeLatest(INCREASE_CART_COUNT,increaseCartCountSaga);
}